<template>
    <div class="case_item">
        <el-image :src="data.Cover" fit="cover" lazy></el-image>
        <div class="case_item_content">
            <p>{{data.Title}}</p>
            <p>{{data.Summary}}</p>
            <div @click="handleGoDetail">{{$t('maijia.knowMore')}} <i class="el-icon-arrow-right"></i> </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        data: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    created() {
    },
    methods: {
        handleGoDetail() {
            this.$router.push({ name: 'MaiJiaCaseDetail', query: { NewsID: this.data.NewsID } })
        }
    }
}
</script>

<style lang="scss" scoped>
.case_item {
    width: 1200px;
    height: 354px;
    position: relative;
    margin-bottom: 40px;
    & .el-image {
        width: 487px;
        height: 274px;
        position: absolute;
        z-index: 1000;
    }

    & .case_item_content {
        width: 1100px;
        height: 317px;
        position: absolute;
        top: 37px;
        left: 100px;
        background: #2c2c2c;
        padding: 60px 60px 0 447px;
        & p {
            color: #ffffff;
        }
        & p:nth-child(1) {
            font-size: 24px;
        }
        & p:nth-child(2) {
            font-size: 14px;
            padding: 10px 0 40px;
        }
        & div {
            padding:0 10px;
            text-align: center;
            line-height: 44px;
            border: 1px solid #ffffff;
            color: #fff;
            display: inline-block;
            cursor: pointer;
        }
        & div:hover {
            background-color: #fff;
            color: #000;
        }
    }
}
</style>